import React, { Component } from 'react';
import { Modal, Input, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const Config = {
    addFirCatalog: {
        title: '新增一级目录',
        url: API_URL.deptFile.addFirstIndexCatalog,
    },
    editFirCatalog: {
        title: '修改一级目录',
        url: API_URL.deptFile.updateFirstIndexCatalog,
    },
    addCatalog: {
        title: '新增目录',
        url: API_URL.deptFile.addFileCatalog,
    },
    editCatalog: {
        title: '修改目录',
        url: API_URL.deptFile.updateFileCatalog,
    },
}

class UpdateCatalog extends Component {
    state = {
        config: {},
        visible: false,
        loading: false,
        id: '',
        catalogName: '',
    }

    show = (type, id, name) => {
        this.setState({
            config: Config[type],
            visible: true,
            id,
            catalogName: name,
        });
    }

    hide = () => {
        this.setState({
            config: {},
            visible: false,
        });
    }

    submit = () => {
        const {
            config,
            id,
            catalogName,
        } = this.state;
        if (!catalogName) {
            message.warning('请输入目录名称');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: config.url,
            data: {
                catalogId: id,
                parentId: id,
                catalogName,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleInputChange = (e) => {
        this.setState({ catalogName: e.target.value });
    }

    getContent = () => {
        const { catalogName } = this.state;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">{asterisk}目录名称:</div>
                    <div className="item-right">
                        <Input
                            style={{ width: 180 }}
                            placeholder="请输入"
                            value={catalogName}
                            onChange={e => this.handleInputChange(e)}
                        />
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const { config, visible, loading } = this.state;
        return (
            <Modal
                title={config.title}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="480px"
                bodyStyle={{ minHeight: 120 }}
            >
                <Spin spinning={loading}>
                    <div className="modal-content">
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateCatalog;


// WEBPACK FOOTER //
// ./src/components/documentManagement/departmentalDocuments/UpdateCatalog.js